import { Stream } from '@cloudflare/stream-react'
import { useRef } from 'react'

import PropTypes from 'prop-types'

const VideoPlayer = ({ poster, src }) => {
  const videoRef = useRef(null)

  const pauseOthers = () => {
    const streams = document.getElementsByTagName('stream')

    if (streams && streams.length) {
      Array.prototype.forEach.call(streams, stream => {
        if (stream !== videoRef.current) {
          if (typeof stream.pause === 'function') {
            stream.pause()
          }
        }
      })
    }
  }

  return (
    <div className="video-stream-container" key={src}>
      {src && (
        <Stream
          src={src}
          streamRef={videoRef}
          controls
          onPlay={pauseOthers}
          onPlaying={pauseOthers}
          {...(poster && { poster })}
        />
      )}
    </div>
  )
}

VideoPlayer.propTypes = {
  poster: PropTypes.string,
  src: PropTypes.string.isRequired,
}

VideoPlayer.defaultProps = {
  poster: null,
}

export default VideoPlayer
